import { FocusableOption } from '@angular/cdk/a11y';
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { UrlUtilsService } from '@rd/core/services/url-utils/url-utils.service';
import { Enrollment, LoyaltyCurrency, PointsAccount } from '@rd/types';

@Component({
  selector: 'rd-anz-card-selector',
  templateUrl: './card-selector.component.html',
  styleUrls: ['./card-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AnzCardSelectorComponent implements FocusableOption {
  // We pass the PointsAccount here since the relationship of enrollment to pointsAcccount
  // is 1 to 1 for ANZ
  constructor(private urlUtilsService: UrlUtilsService) {}
  @ViewChild('button') button: ElementRef;
  @Output() clickEvent = new EventEmitter<PointsAccount>();
  @Input() active = false;
  @Input() pointsAccount: PointsAccount;
  @Input() loyaltyCurrency: LoyaltyCurrency;

  focus(): void {
    this.button.nativeElement.focus();
  }

  get enrollment(): Enrollment {
    return this.pointsAccount?.enrollments[0];
  }

  get pointsBalance(): number {
    return this.pointsAccount?.pointsBalance;
  }

  get currency(): string {
    return this.loyaltyCurrency?.name;
  }

  get name(): string {
    return this.enrollment?.groupName;
  }

  click(pointsAccount: PointsAccount): void {
    this.button.nativeElement.blur();
    this.clickEvent.emit(pointsAccount);
  }

  get imgUrl(): string {
    const supportedImages = new Map([
      ['301', '301'],
      ['302', '301'], // 302 uses the same image as 301
      ['304', '304'],
      ['308', '308'],
      ['312', '312'],
    ]);
    const code =
      supportedImages.get(this.enrollment.productCode) ?? 'anz_unavailablecard';
    return this.urlUtilsService.imageUrl(`/images/${code}.png`);
  }
}
